/**
 * True for a non-empty string suitable as a signed HTTP(S) URL from the API
 * (APIs sometimes serialize null as the literal "null").
 */
export const isNonEmptySignedUrl = (value: unknown): value is string =>
  typeof value === "string" && value !== "null" && value.trim() !== "";
